import { configureStore } from '@reduxjs/toolkit';
import localizationSlice from './localizationSlice';
import modalSlice from './modalSlice';
import notificationSlice from './notificationSlice';
import authSlice from './authSlice';
import adminSlice from './adminSlice';
import confirmSlice from './confirmSlice';
import applicationSlice from './applicationSlice';
import processSlice from './processSlice';
import paymentSlice from './paymentSlice';

const store = configureStore({
  reducer: {
    localizations: localizationSlice,
    modal: modalSlice,
    notifications: notificationSlice,
    confirm: confirmSlice,
    auth: authSlice,
    admin: adminSlice,
    applications: applicationSlice,
    processes: processSlice,
    payments: paymentSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'notifications/addNotification',
          'modal/openModal',
          'confirm/showConfirm'
        ],
        ignoredPaths: [
          'notifications.items',
          'modal.content',
          'modal.callback',
          'confirm.header',
          'confirm.body',
          'confirm.message',
          'confirm.okValue',
          'confirm.cancelValue',
          'confirm.onConfirm'
        ]
      },
      immutableCheck: {
        ignoredPaths: ['notifications.items', 'modal.content', 'confirm.body']
      }
    }),
  devTools: process.env.NODE_ENV !== 'production'
});

export default store;
